import React from "react";
import { ArrowDown, ArrowUp, Minus } from "lucide-react";

export const KpiCard = ({ label, value, delta, icon: Icon, testid, accent = "#0070F2" }) => {
  const positive = delta != null && delta > 0;
  const negative = delta != null && delta < 0;
  const Arrow = positive ? ArrowUp : negative ? ArrowDown : Minus;
  const deltaColor = positive ? "text-emerald-600 bg-emerald-50" : negative ? "text-rose-600 bg-rose-50" : "text-slate-500 bg-slate-50";

  return (
    <div
      data-testid={testid}
      className="bg-white rounded-lg border border-slate-200 shadow-sm p-5 hover:shadow-md transition-shadow fade-up"
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] tracking-[0.08em] uppercase text-slate-500 font-semibold">{label}</div>
        {Icon && (
          <div className="w-8 h-8 rounded-md flex items-center justify-center" style={{ background: `${accent}14` }}>
            <Icon className="w-4 h-4" style={{ color: accent }} strokeWidth={2.2} />
          </div>
        )}
      </div>
      <div data-testid={`${testid}-value`} className="font-display text-3xl font-bold tracking-tight text-slate-900 mt-3 tabular-nums">
        {value}
      </div>
      {delta != null && (
        <div className="mt-3 flex items-center gap-2">
          <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded ${deltaColor}`}>
            <Arrow className="w-3 h-3" /> {Math.abs(delta)}%
          </span>
          <span className="text-xs text-slate-500">önceki döneme göre</span>
        </div>
      )}
    </div>
  );
};
